import React from 'react';
import MaskedInput from 'react-text-mask';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.ACCOUNT_NUMBER
};
export const AccountNumber = props => {
  var _a;
  const mask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // Up to 9 digits
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[(_a = props.funnel) !== null && _a !== void 0 ? _a : ''] || LABELS.ARHI
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      inputMode: "numeric",
      pattern: "\\d*"
    })
  }));
};
const AccountNumberWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(AccountNumber, {
  ...props
}));
AccountNumber.defaultProps = defaultFieldPropTypes;
export default AccountNumberWithFunnel;